import { useEffect } from 'react';
import { FleetSidebar } from '@/components/layout/FleetSidebar';
import { TelemetryPanel } from '@/components/layout/TelemetryPanel';
import { MapView } from '@/map/MapView';
import { useSelection } from '@/store/selection';

/**
 * Renders a single panel full-screen — used by popped-out native windows.
 * URL form: `?solo=<mode>[&robot=<id>]`
 */
export function SoloView({ mode }: { mode: string }) {
  const params = new URLSearchParams(window.location.search);
  const robotId = params.get('robot');

  // If the pop-out specifies a robot, select it on mount so the panel knows
  // what to focus.
  useEffect(() => {
    if (robotId) useSelection.getState().select(robotId);
  }, [robotId]);

  switch (mode) {
    case 'telemetry':
      return (
        <div className="ml-auto h-full">
          <TelemetryPanel />
        </div>
      );
    case 'map':
      return (
        <div className="h-full w-full">
          <MapView />
        </div>
      );
    case 'fleet':
      return (
        <div className="h-full">
          <FleetSidebar />
        </div>
      );
    default:
      return (
        <div className="grid h-full place-items-center">
          <p className="text-sm text-fg-muted">unknown solo mode: {mode}</p>
        </div>
      );
  }
}
